export default function () {
  const page = document.querySelector('.PageMain--category-landing .CareCredit')

  if (!page) {
    return
  }

  const anchorLinks = Array.from(
    page.querySelectorAll('.CareCredit__items .wp-block-columns a')
  )

  anchorLinks.forEach((anchorLink) => {
    anchorLink.addEventListener('click', function (e) {
      const elementHash = this.hash ? document.querySelector(this.hash) : null

      if (elementHash) {
        e.preventDefault()

        const scrollPosition = elementHash.offsetTop

        window.scrollTo({
          top: scrollPosition,
          left: 0,
          behavior: 'smooth',
        })
      }
    })
  })

  // Video Section
  const videoSectionGroups = Array.from(
    page.querySelectorAll(
      '.CareCredit__video-section .wp-block-group__inner-container .wp-block-group'
    )
  )

  const videoSectionParagraphs = Array.from(
    page.querySelectorAll(
      '.CareCredit__video-section .wp-block-group__inner-container .wp-block-group p'
    )
  )

  videoSectionParagraphs.forEach((p) => {
    p.addEventListener('click', () => {
      videoSectionGroups.forEach((g) => {
        g.classList.remove('opened')
      })

      p.parentNode.parentNode.classList.add('opened')
    })
  })

  // Posts Buttons
  const postsBtns = Array.from(
    page.querySelectorAll(
      '.CareCredit__posts .CareCredit__posts-btns .wp-block-buttons .wp-block-button a'
    )
  )

  postsBtns.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      const careCreditPosts = button.closest('.CareCredit__posts')

      if (!careCreditPosts) {
        return
      }

      const postsBtnsGroups = Array.from(
        careCreditPosts.querySelectorAll(
          '.CareCredit__posts .CareCredit__posts-btns .wp-block-buttons .wp-block-button'
        )
      )
      const shortCodeContainer = Array.from(
        careCreditPosts.querySelectorAll(
          '.CareCredit__posts div.CareCredit__posts-shortcode-container .wp-block-group__inner-container > .wp-block-group'
        )
      )

      postsBtnsGroups.forEach((buttonGroup) => {
        buttonGroup.classList.remove('opened')
      })

      shortCodeContainer.forEach((shortcodeGroup) => {
        shortcodeGroup.classList.remove('opened')
      })

      button.parentNode.classList.add('opened')

      const shortCodeHash = button.hash
        ? document.querySelector(button.hash)
        : null

      if (shortCodeHash) {
        shortCodeHash.classList.add('opened')
      }
    })
  })
}
